import axios from 'axios'
import {jsonHeader} from '@/helpers/axiosHeaders'
import api from "@/helpers/api";

const state = {
    curItemData: {},
    items: {
        standardMeasure: {
            name: 'standardMeasure',
            show: false
        },
        takeDayOff: {
            name: 'takeDayOff',
            show: false,
        },
        leave: {
            name: 'leave',
            show: false,
        },
        workOvertime: {
            name: 'workOvertime',
            show: false,
        },
        errorSocket: {
            name: 'errorSocket',
            show: false,
        },
        workTime: {
            name: 'workTime',
            show: false,
        },
    },
}

// getters
const getters = {

}

const actions = {
    open(context, data) {
        if(data.name && state.items.hasOwnProperty(data.name)) {
            setTimeout(()=>{
                context.commit('open', {name:data.name, request:data.request});
            },10);
        }
    },
}

const mutations = {
    close(state, data) {
        if(data.name && state.items.hasOwnProperty(data.name)) {
            state.items[data.name].show = false;
            state.curItemData = {};
            document.getElementsByTagName('body')[0].classList.remove("noscroll");
        }
    },
    open(state, data) {
        if(data.name && state.items.hasOwnProperty(data.name)) {
            if(data.request !== false){
                state.curItemData = data.request;
            }
            state.items[data.name].show = true;
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
